export const planType = {
  PLAN: 'plan',
  ADDON: 'addon',
  CHARGE: 'charge',
};

export type PlanTypes = typeof planType[keyof typeof planType];
